// extracted by mini-css-extract-plugin
export default {"brpLogo":"brpLogo_brpLogo__o+i7c"};